module.exports = __webpack_public_path__ + "img/user.0cac1d5b.svg";